import React from 'react';

class ContactForm extends React.Component {
    constructor(props) {
      super();
      this.state = {
        input: {
          name:'',
          phone:null,
          email:'',
          company:'',
        },
        errors: {}

      }
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    render() {
      return(
        <form id="contact-form" onSubmit={this.handleSubmit} method="POST" className="contact-form">
          <div className="error-container"><span>{this.state.errors.main_error}</span></div>
          <div className="success-container"><span>{this.state.errors.main_success}</span></div>
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={this.state.input.name}
            onChange={this.handleChange}
            />
            <div className="error-container"><span>{this.state.errors.name}</span></div>

          <label htmlFor="phone">Phone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={this.state.input.phone}
            onChange={this.handleChange}
            />
            <div className="error-container"><span>{this.state.errors.phone}</span></div>

          <label htmlFor="email">Email</label>
          <input
            type="text"
            id="email"
            name="email"
            value={this.state.input.email}
            onChange={this.handleChange}
            />
            <div className="error-container"><span>{this.state.errors.email}</span></div>

          <label htmlFor="company">Company</label>
          <input
            type="text"
            id="company"
            name="company"
            value={this.state.input.company}
            onChange={this.handleChange}
            />
          <div className="error-container"><span>{this.state.errors.company}</span></div>

          <input className="submit-button" type="submit" value="Register for Demo" />
        </form>
      );
    }
  
    handleChange(event) {
     // this.validate();
      let input = this.state.input;
      input[event.target.name] = event.target.value;
    
      this.setState({
        input
      });
    }
      
    handleSubmit(event) {
      event.preventDefault();
    
      if(this.validate()){

        fetch('api/Customers', {
          method: "POST",
          body: JSON.stringify(this.state.input),
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
        })
        .then(response => response.json().then(data => ({status: response.status, body: data})))
        .then((data)=> {
          if (data.status === 201 ) {
            this.resetForm()
            let errors = {};
            errors["main_success"] = "Your email has been registered! Thanks!"
            this.setState({
              errors: errors
            });
            return data
          } else if(data.status === 409) {
            let errors = {};
            errors["main_error"] = data.body.main_error.errors[0].errorMessage
            this.setState({
              errors: errors
            });
          }
          else if (data.status === 400){
            let errors = {};
            errors["main_error"] = JSON.stringify(data.body.errors);
            this.setState({
              errors: errors
            });
          }
        })

      }
    }

    validate(){
      let input = this.state.input;
      let errors = {};
      let isValid = true;
  
      if (!input["name"]) {
        isValid = false;
        errors["name"] = "Please enter your name.";
      }
  
      // var telPattern=new RegExp(/^[0-9]/i);
      // if (input["phone"]!==''&&!telPattern.test(input["phone"])) {
      //   isValid = false;
      //   errors["phone"] = "Phone number should be a number.";
      // }

      if (!input["email"]) {
        isValid = false;
        errors["email"] = "Please enter your email.";
      }
  
      if (typeof input["email"] !== "undefined") {
          
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(input["email"])) {
          isValid = false;
          errors["email"] = "Please enter a valid email.";
        }
      }
  
      this.setState({
        errors: errors
      });
  
      return isValid;
    }

    // This is to reset for following submission
    resetForm(){
      let input = {};
      input["name"] = "";
      input["phone"] = "";
      input["email"] = "";
      input["company"] = "";
      //input["isSubscribedToNewsletter"] = "";

      this.setState({input:input});
    }

  }
  
  export default ContactForm;